<template>
  <div class="store-selective">
    <div
      v-for="(listing, index) in listings"
      :key="index"
      class="listing-item"
      @click="handleToProductDetailClick(listing)"
    >
      <div class="image">
        <img v-lazy="listing.image" :alt="listing.title" class="product-image">
      </div>
      <p class="p-title">{{ listing.title }}</p>
      <p class="p-price">{{ $currencySymbol() }} {{ $toThousandsFn(listing.minPrice) }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  buildProductDetailStoreSpecifiedSource,
  resolveIsFlashSaleTag
} from '@/plugins/utils'

defineProps<{ listings: any[] }>()

const handleToProductDetailClick = (item: IYouMayLikeItem & {
  highlights?: string[]
  defaultSkuId?: number
}) => {
  const { listingId, title, shortTitle, skuId, defaultSkuId, highlights } = item
  const flashSkuId = Number(defaultSkuId || skuId || 0)
  const isFlashSale = resolveIsFlashSaleTag(highlights) && flashSkuId > 0

  useNuxtApp().$toListingDetail(
    isFlashSale ? flashSkuId : listingId,
    {
      source: buildProductDetailStoreSpecifiedSource(),
      title,
      shortTitle,
      ...(isFlashSale
        ? { from: 'flash-sale' as const }
        : { skuId: defaultSkuId || skuId })
    }
  )
}
</script>

<style lang="scss" scoped>
.title-text{
  padding: 10px 0;
  text-align: center;
  font-size: 28px;
}
.store-selective{
  display: flex;
  flex-wrap: no-wrap;
  overflow-y: auto;
  padding-bottom: 20px;
}
.store-selective::-webkit-scrollbar {
  display: none;
}
.listing-item{
  $w: calc(100vw / 5);
  padding: 5px;
  width: $w;
  min-width: $w;
  .image{
    width: 100%;
    padding-bottom: 100%;
    height: 0;
    position: relative;
    img{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .p-title{
    margin: 10px 0;
    font-size: 22px;
    @include ellipsisMultiline(2);
  }
  .p-price{
    font-weight: 600;
    font-size: 24px;
    color: #000;
  }
}
</style>